'use client';

import { QuantitySelectButton } from './components';
import { useQuantitySelector } from './hook';

import { Icon } from '../ui';

type QuantitySelectorProps = {
  count: number;
  onSetCount: (value: number) => void;
  min?: number;
  max?: number;
  incrementStep?: number;
  decrementStep?: number;
};

export const QuantitySelector = ({
  onSetCount,
  count,
  min,
  max,
  incrementStep,
  decrementStep,
}: QuantitySelectorProps) => {
  const {
    decrement,
    increment,
    startIncrementHold,
    stopIncrementHold,
    startDecrementHold,
    stopDecrementHold,
    handleKeyDown,
    handlePaste,
    handleSubmit,
    register,
    errors,
    onValid: onValidHook,
    handleChange,
  } = useQuantitySelector({ count, onSetCount, min, max, incrementStep, decrementStep });

  return (
    <form data-cy="quantity-selector" onChange={handleSubmit(onValidHook)}>
      <div className="flex items-center gap-1 md:gap-1.5 h-14">
        <QuantitySelectButton
          data-cy="quantity-selector-decrement-button"
          onClick={decrement}
          onMouseUp={stopDecrementHold}
          onTouchEnd={stopDecrementHold}
          onMouseLeave={stopDecrementHold}
          onMouseDown={startDecrementHold}
          onTouchStart={startDecrementHold}
        >
          <Icon.Minus width={24} height={24} className="text-foreground" />
        </QuantitySelectButton>

        <div className="flex flex-col relative items-center justify-center mt-1.5 mb-2 bg-background-variant px-2.5 h-full rounded-md border-2 border-primary/10">
          <span className="font-medium text-xs text-foreground/50 uppercase">
            Números
          </span>
          <input
            data-cy="quantity-selector-input"
            type="number"
            maxLength={4}
            inputMode="numeric"
            onPaste={handlePaste}
            onKeyDown={handleKeyDown}
            {...register('count')}
            onChange={(e) => {
              handleChange(e);
              register('count').onChange(e);
            }}
            className="bg-transparent text-foreground text-2xl font-semibold text-center w-16 outline-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none [-moz-appearance:textfield]"
          />
        </div>

        <QuantitySelectButton
          data-cy="quantity-selector-increment-button"
          onClick={increment}
          onMouseUp={stopIncrementHold}
          onTouchEnd={stopIncrementHold}
          onMouseLeave={stopIncrementHold}
          onMouseDown={startIncrementHold}
          onTouchStart={startIncrementHold}
        >
          <Icon.Plus width={24} height={24} className="text-foreground" />
        </QuantitySelectButton>
      </div>
      {errors.count && (
        <span className="text-red-500 text-xs text-left w-max leading-none mb-10">
          {errors.count.message}
        </span>
      )}
    </form>
  );
};
